import React from 'react';

export default class Page6 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToActivelyListen');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Think of opportunities that occur in your current work or
                                                elsewhere, to practise. You may want to consider situations
                                                where you have to interact with other people, whether one-to-one
                                                or in group meetings.</p>
                                            <div className="border_subtitle">Active listening feedback
                                                exercise
                                            </div>
                                            <p>Ask someone you trust, for example your mentor, line manager or
                                                colleague to present you with 10 minutes’ information about a
                                                particular subject. If possible, ask a third party to observe.
                                                After the 10 minutes, summarise what you’ve heard. Apart from
                                                recounting facts, try saying things like:<span
                                                    className="subtiltereg"> ‘What I understand is that…’</span>.
                                                Then ask both the speaker and observer to comment on how much
                                                you were able to pick up.</p>
                                            <div className="border_subtitle">Observe others</div>
                                            <p>Ask others how they actively listen. Explain what you mean and
                                                are looking for, using the information in this tool to help you.
                                                Observe them and see first hand what they do well or not so
                                                well.</p>
                                            <div className="browncontentbg uiheading "><p>Repeat the exercise a
                                                month later, having re-read this tool, to check your progress
                                                and use some of the techniques we’ve talked about. Watch other
                                                people ‘listening,’ too!</p></div>
                                            <br/>
                                                <div className="circle_title"><img
                                                    src={require('@images/browndot.jpg')}
                                                    alt=""/>Further Information</div>
                                                <div className="paraspace"><p>If you found this tool useful then
                                                    you are likely to find the following tools both insightful
                                                    and relevant:</p></div>
                                                <div className="keyquestionpad">
                                                    <ul className="greenbullet-list sept">

                                                        <li><div className="link_color button-link-redirect people"
                                                               onClick={this._savePageStatus('HowToCommunicateEffectively')}>How
                                                            to communicate effectively</div></li>
                                                        <li><div className="link_color button-link-redirect people"
                                                               onClick={this._savePageStatus('HowToDevelopRapport')}>How
                                                            to develop rapport</div></li>
                                                        <li><div className="link_color button-link-redirect people"
                                                               onClick={this._savePageStatus('HowToManageDifficultConversations')}>How
                                                            to manage difficult conversations</div></li>
                                                        <li><div className="link_color button-link-redirect people"
                                                               onClick={this._savePageStatus('HowToGiveFeedback')}>How
                                                            to give feedback.</div></li>
                                                    </ul>
                                                </div>
                                                <div className="circle_title "><img
                                                    src={require('@images/browndot.jpg')}
                                                    alt=""/>REFERENCES</div>

                                                <ol className="testclass">
                                                    <li><p className="further_info_content">Conway, A. R.,
                                                        Cowan, N., &amp; Bunting, M. F. (2001). The cocktail
                                                        party phenomenon revisited: The importance of working
                                                        memory capacity.<span className="subtiltereg"> Psychonomic Bulletin &amp; Review</span>,
                                                        8(2), 331-335.</p></li>
                                                    <li><p className="further_info_content">Koch, I., Lawo, V.,
                                                        Fels, J., &amp; Vorländer, M. (2011). Switching in the
                                                        cocktail party: Exploring intentional control of
                                                        auditory selective attention.<span
                                                            className="subtiltereg"> Journal of Experimental Psychology: Human Perception and Performance</span>,
                                                        37(4), 1140.</p></li>
                                                    <li><p className="further_info_content"> Noble, W., and
                                                        Perret, S. (2002). ‘Hearing speech against spatially
                                                        separate competing speech versus competing noise,’<span
                                                            className="subtiltereg"> Perception Psychophysics</span>.
                                                        64, 1325-1336.</p></li>
                                                    <li><p className="further_info_content">Manktelow, J.
                                                        (2003).<span className="subtiltereg">  Introduction to Memory Techniques</span>,
                                                        London and New York: Routledge</p></li>
                                                    <li><p className="further_info_content">De Boer, J.
                                                        (2006).<span className="subtiltereg"> Better results with active listening.</span> UK
                                                        Training Articles.</p></li>
                                                    <li><p className="further_info_content"> Mehrabian, A.
                                                        (1981).<span className="subtiltereg"> Silent messages: Implicit communication of emotions and attitudes (2nd ed.).</span> Wadsworth,
                                                        Belmont, California.</p></li>


                                                </ol>


                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page5')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this._savePageStatus('People')}
                                                        className="button-next-previous-done">Done
                                                    </div>
                                                </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }